import {testIdProps} from '@github-ui/test-id-props'
import {BellIcon, BellSlashIcon} from '@primer/octicons-react'
import {useCallback} from 'react'

import {useNotificationSubscriptions} from '../state-providers/notification-subscriptions/notification-subscriptions-context'
import {StatusUpdatesResources} from '../strings'
import {IconButtonWithTooltip} from './common/icon-button-with-tooltip'

export const NotificationSubscriptionsToggle = () => {
  const {viewerIsSubscribed, subscribe, unsubscribe, isLoading} = useNotificationSubscriptions()
  const label = viewerIsSubscribed
    ? StatusUpdatesResources.unsubscribeFromUpdates
    : StatusUpdatesResources.subscribeToUpdates

  const handleOnClick = useCallback(async () => {
    if (viewerIsSubscribed) {
      unsubscribe()
    } else {
      subscribe()
    }
  }, [subscribe, unsubscribe, viewerIsSubscribed])

  const icon = viewerIsSubscribed ? BellSlashIcon : BellIcon

  return (
    <IconButtonWithTooltip
      {...testIdProps('notification-subscriptions-toggle')}
      aria-checked={viewerIsSubscribed}
      disabled={isLoading}
      onClick={handleOnClick}
      icon={icon}
      label={label}
      variant="invisible"
      tooltipDirection="s"
    />
  )
}

try{ NotificationSubscriptionsToggle.displayName ||= 'NotificationSubscriptionsToggle' } catch {}